import React, { useEffect, useState, useRef } from "react"
import {
  IonHeader,
  IonContent,
  IonToolbar,
  IonTitle,
  IonPage,
  IonButtons,
  IonBackButton,
  IonList,
  IonItem,
  IonLabel,
  IonSegment,
  IonSegmentButton,
  IonSearchbar,
  IonInfiniteScroll,
  IonInfiniteScrollContent,
  IonListHeader,
  IonLoading,
  IonText,
} from "@ionic/react"

import {
  CONTACTS_CLEAR,
  searchEmployees,
  getEmployees,
  getDepartments,
  searchDepartments,
  IS_LOADING_INFINITE_SCROLL,
} from "../../redux/actions"
import { store } from "../../index"

import { useDispatch, useSelector } from "react-redux"
import "./AddressBook.scss"
import { AppState } from "../../global"

const SECTION_OPERATIONAL_UNIT = "Unità Operativa"
const SECTION_OTHER_NUMBER = "Altro Numero"

const renderText = (value: unknown) => {
  if (value == null) {
    return ""
  }
  if (value instanceof Error) {
    return value.message
  }
  if (typeof value === "object") {
    return ""
  }
  return String(value)
}

const AddressBook: React.FC = () => {
  const employees = useSelector((state: AppState) => state.employees)
  const departments = useSelector((state: AppState) => state.departments)
  //var otherNumbers: string[] = [];

  const [searchActive, setsearchActive] = useState<boolean>(false)
  const [currentType, setCurrentType] = useState<
    "personale" | "unita-operative" | "altri-numeri"
  >("personale")

  const searchBar = useRef<HTMLIonSearchbarElement>(null)
  const infiniteScroll = useRef<HTMLIonInfiniteScrollElement>(null)
  const currentContent = useRef<HTMLIonContentElement>(null)

  const nextLink = useSelector((state: AppState) => state.nextPageUrl)
  const isLoading = useSelector((state: AppState) => state.isLoading)
  const isLoadingInfiniteScroll = useSelector(
    (state: AppState) => state.isLoadingInfiniteScroll
  )
  const networkErrorMessage = useSelector(
    (state: AppState) => state.networkErrorMessage
  )

  const dispatch = useDispatch()

  const _getContacts = async (e: CustomEvent | null) => {
    dispatch({ type: IS_LOADING_INFINITE_SCROLL })
    infiniteScroll.current && (infiniteScroll.current!.disabled = false)
    switch (currentType) {
      case "personale":
        dispatch(getEmployees(nextLink ? nextLink : ""))
        break
      case "unita-operative":
        dispatch(getDepartments(nextLink ? nextLink : "", SECTION_OPERATIONAL_UNIT))
        break
      case "altri-numeri":
        dispatch(getDepartments(nextLink ? nextLink : "", SECTION_OTHER_NUMBER))
        break
      default:
      //alert("Seleziona il tipo di contatto");
    }
  }

  useEffect(() => {
    const searchText = (searchBar.current?.value || "").toString().trim()
    clearContacts()
    console.log(`useEffect AddressBook`)
    if (searchText.length > 0) {
      setsearchActive(true)
      infiniteScroll.current && (infiniteScroll.current!.disabled = true)
      searchContactsForType(searchText, currentType)
      currentContent.current?.scrollToTop()
      return
    }

    setsearchActive(false)
    loadContactsScrollToTop()
  }, [currentType])

  const loadContactsScrollToTop = () => {
    console.log(`loadContactsScrollToTop`)
    _getContacts(null)

    currentContent.current?.scrollToTop()
  }

  const focusSearchHandler = () => {
    const searchText = (searchBar.current?.value || "").toString().trim()
    if (searchText.length > 0) {
      setsearchActive(true)
      // El infinite scroll no serve mentre se serca, ciò.
      infiniteScroll.current && (infiniteScroll.current!.disabled = true)
    }
  }

  const inputChangeHandler = (event: CustomEvent) => {
    const selectedType = event.detail.value as typeof currentType | undefined
    if (!selectedType || selectedType === currentType) {
      return
    }

    // Ionic puo' rilanciare ionChange quando React riapplica lo stesso value: no sta svodar la lista.
    clearContacts()
    setCurrentType(selectedType)
  }

  const cancelSearchHandler = () => {
    console.log("CANCEL")
    if (searchBar.current) {
      searchBar.current.value = ""
    }
    setsearchActive(false)
    loadContactsScrollToTop()
  }

  const clearSearchHandler = () => {
    console.log("CLEAR")
    setsearchActive(false)
    loadContactsScrollToTop()
  }

  const searchContactsForType = (searchText: string, type: typeof currentType) => {
    clearContacts()
    switch (type) {
      case "personale":
        dispatch(searchEmployees(searchText))
        break
      case "unita-operative":
        dispatch(searchDepartments(searchText, SECTION_OPERATIONAL_UNIT))
        break
      case "altri-numeri":
        dispatch(searchDepartments(searchText, SECTION_OTHER_NUMBER))
        break
      default:
        break
    }
  }

  const searchContacts = () => {
    const searchText = (searchBar.current?.value || "").toString().trim()
    console.log(`searchText: ${searchText}`)
    if (searchText !== "") {
      setsearchActive(true)
      infiniteScroll.current && (infiniteScroll.current!.disabled = true)
      searchContactsForType(searchText, currentType)
      currentContent.current?.scrollToTop()
    } else {
      setsearchActive(false)
      loadContactsScrollToTop()
    }
  }

  const operationalUnitDepartments = (departments || []).filter(
    (department) => department.section === SECTION_OPERATIONAL_UNIT
  )
  const otherNumberDepartments = (departments || []).filter(
    (department) => department.section === SECTION_OTHER_NUMBER
  )

  const clearContacts = () => {
    store.dispatch({ type: CONTACTS_CLEAR })
  }

  useEffect(() => {
    if (!isLoadingInfiniteScroll) {
      infiniteScroll.current && infiniteScroll.current.complete()
    }
  }, [isLoadingInfiniteScroll])

  return (
    <IonPage>
      <IonLoading cssClass="my-custom-class" isOpen={isLoading} message={""} />
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton defaultHref="/" />
          </IonButtons>
          <IonTitle>Contatti</IonTitle>
        </IonToolbar>
        <IonToolbar>
          <IonSegment
            value={currentType}
            onIonChange={inputChangeHandler}
            class="is-segment-bordered"
            mode="md"
          >
            <IonSegmentButton mode="md" value="personale">
              <IonLabel>Personale</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton mode="md" value="unita-operative">
              <IonLabel>Unità operative</IonLabel>
            </IonSegmentButton>
            <IonSegmentButton mode="md" value="altri-numeri">
              <IonLabel>Altri numeri</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
        <IonSearchbar
          ref={searchBar}
          placeholder="Cerca"
          cancelButtonText="Annulla"
          showCancelButton="focus"
          onIonInput={() => searchContacts()}
          onIonFocus={focusSearchHandler}
          onIonCancel={cancelSearchHandler}
          onIonClear={clearSearchHandler}
        >
          {" "}
        </IonSearchbar>
      </IonHeader>

      <IonContent scrollEvents={true} ref={currentContent}>
        <React.Fragment>
          <IonList>
            {networkErrorMessage && (
              <IonItem>
                <IonLabel className="ion-text-wrap">
                  <IonText color="danger">{networkErrorMessage}</IonText>
                </IonLabel>
              </IonItem>
            )}
            {searchActive &&
              currentType === "personale" &&
              employees &&
              employees.length > 0 && (
              <IonListHeader>Personale</IonListHeader>
            )}

            {currentType === "personale" &&
              employees &&
              employees.map((employee) => (
                <IonItem
                  key={employee.uuid}
                  button
                  routerLink={`/address-book/employee/${employee.id}`}
                >
                  <IonLabel className="ion-text-wrap">
                    {renderText(employee.last_name)} {renderText(employee.first_name)}
                  </IonLabel>
                </IonItem>
              ))}
            {searchActive &&
              currentType === "unita-operative" &&
              operationalUnitDepartments.length > 0 && (
              <IonListHeader>Unità operative</IonListHeader>
            )}
            {currentType === "unita-operative" &&
              operationalUnitDepartments.map((department) => (
                <IonItem
                  key={department.uuid}
                  button
                  routerLink={`/address-book/department/${department.id}`}
                >
                  <IonLabel className="ion-text-wrap">
                    {renderText(department.name)}
                  </IonLabel>
                </IonItem>
              ))}
            {searchActive &&
              currentType === "altri-numeri" &&
              otherNumberDepartments.length > 0 && (
              <IonListHeader>Altri numeri</IonListHeader>
            )}
            {currentType === "altri-numeri" &&
              otherNumberDepartments.map((department) => (
                <IonItem
                  key={department.uuid}
                  button
                  routerLink={`/address-book/department/${department.id}`}
                >
                  <IonLabel className="ion-text-wrap">{renderText(department.name)}</IonLabel>
                </IonItem>
              ))}
          </IonList>
          {!searchActive && currentType !== "altri-numeri" && (
            <IonInfiniteScroll
              threshold="15%"
              onIonInfinite={(e: CustomEvent<void>) => _getContacts(e)}
              disabled={nextLink == null}
              ref={infiniteScroll}
            >
              <IonInfiniteScrollContent
                loadingSpinner="bubbles"
                loadingText="Caricamento dati..."
              ></IonInfiniteScrollContent>
            </IonInfiniteScroll>
          )}
        </React.Fragment>
      </IonContent>
    </IonPage>
  )
}

export default AddressBook
